import React, {
    createContext,
    ReactNode,
    useContext,
    useEffect,
    useMemo,
    useState,
} from 'react'
import { usePreviewFeatures } from 'shared/hooks/usePreviewFeatures'

interface RightMostPaneContextType {
    showRightMostPane: boolean
    setShowRightMostPane: React.Dispatch<React.SetStateAction<boolean>>
}

interface RightMostPaneProviderProps {
    children: ReactNode
}

const RightMostPaneContext = createContext<
    RightMostPaneContextType | undefined
>(undefined)

export const RightMostPaneProvider = ({
    children,
}: RightMostPaneProviderProps) => {
    const { previewFeatures } = usePreviewFeatures()
    const [showRightMostPane, setShowRightMostPane] = useState(
        false
    )

    const value = useMemo(() => ({ showRightMostPane, setShowRightMostPane }), [
        showRightMostPane,
    ])

    return (
        <RightMostPaneContext.Provider value={value}>
            {children}
        </RightMostPaneContext.Provider>
    )
}

export const useShowRightMostPane = (): RightMostPaneContextType => {
    const context = useContext(RightMostPaneContext)
    if (!context) {
        throw new Error(
            'useShowRightMostPane must be used within a RightMostPaneProvider'
        )
    }
    return context
}
